import * as React from "react";

import { ZAttrMeta } from "../ZAttrMeta";
import { AttrClassesSelect } from "./AttrClassesSelect";
import { AttrDatePicker } from "./AttrDatePicker";
import { AttrEditDefault } from "./AttrEditDefault";
import { AttrEditInput } from "./AttrEditInput";
import { AttrEditParentsSelect } from "./AttrEditParentsSelect";
import { AttrEditSelect } from "./AttrEditSelect";
import { AttrEditSwitch } from "./AttrEditSwitch";
import { AttrEditTextArea } from "./AttrEditTextArea";
import { AttrExternalImages } from "./AttrExternalImages";
import { AttrInputNumber } from "./AttrInputNumber";
import { AttrPrimarySpec } from "./AttrPrimarySpec";
import { AttrRecordSelect } from "./AttrRecordSelect/AttrRecordSelect";
import { AttrSelectValuesModal } from "./AttrSelectValuesModal";
import { AttrSpecsSelectTable } from "./AttrSpecsSelectTable";
import { AttrUploader } from "./AttrUploader";

type PropsAttrEdit = {
  attr: ZAttrMeta;
  value?: unknown;
  onChange?(value?: unknown): void;
  textCvt?(text: string): string;
  disabled?: boolean;
  activateCallback?: (onActive: (() => void) | undefined) => void;
  onBlur: () => void;
};

export const AttrEdit: React.FC<PropsAttrEdit> = ({
  attr,
  value,
  onChange,
  textCvt,
  disabled,
  activateCallback,
  onBlur,
}) => {
  const component = attr.edit?.component;

  if (component) {
    // eslint-disable-next-line default-case
    switch (component.type) {
      case "Input":
        return (
          <AttrEditInput
            attrMeta={attr}
            component={component}
            value={value}
            onChange={onChange}
            disabled={disabled}
            activateCallback={activateCallback}
            onBlur={onBlur}
          />
        );
      case "Select":
        return (
          <AttrEditSelect
            select={component}
            value={value}
            onChange={onChange}
            disabled={disabled}
            activateCallback={activateCallback}
            onBlur={onBlur}
          />
        );
      case "TextArea":
        return (
          <AttrEditTextArea
            params={component}
            value={value}
            onChange={onChange}
            disabled={disabled}
            activateCallback={activateCallback}
            onBlur={onBlur}
          />
        );
      case "InputNumber":
        return (
          <AttrInputNumber
            attrMeta={attr}
            component={component}
            value={value}
            onChange={onChange}
            textCvt={textCvt}
            disabled={disabled}
            activateCallback={activateCallback}
            onBlur={onBlur}
          />
        );
      case "DatePicker":
        return (
          <AttrDatePicker
            attrMeta={attr}
            component={component}
            value={value}
            onChange={onChange}
            textCvt={textCvt}
            disabled={disabled}
            onBlur={onBlur}
          />
        );
      case "Switch":
        return (
          <AttrEditSwitch
            attrMeta={attr}
            component={component}
            value={value}
            onChange={onChange}
            textCvt={textCvt}
            disabled={disabled}
            onBlur={onBlur}
          />
        );
      case "ParentsSelect": {
        return (
          <AttrEditParentsSelect
            attrMeta={attr}
            component={component}
            value={value}
            onChange={onChange}
            disabled={disabled}
            activateCallback={activateCallback}
            onBlur={onBlur}
          />
        );
      }
      case "ClassesSelect":
        return (
          <AttrClassesSelect
            component={component}
            disabled={disabled}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
          />
        );
      case "RecordSelect":
        return (
          <AttrRecordSelect
            attrType={attr.type}
            component={component}
            disabled={disabled}
            value={value}
            onChange={onChange}
            activateCallback={activateCallback}
            onBlur={onBlur}
          />
        );
      case "AttrExternalImages":
        return (
          <AttrExternalImages
            attrType={attr.type}
            value={value}
            onChange={onChange}
            disabled={disabled}
            activateCallback={activateCallback}
            onBlur={onBlur}
          />
        );
      case "Uploader":
        return (
          <AttrUploader
            attrType={attr.type}
            value={value}
            onChange={onChange}
            disabled={disabled}
            activateCallback={activateCallback}
            component={component}
            onBlur={onBlur}
          />
        );
      case "SelectValuesModal":
        return (
          <AttrSelectValuesModal
            attrType={attr.type}
            component={component}
            value={value}
            onChange={onChange}
            disabled={disabled}
            activateCallback={activateCallback}
            onBlur={onBlur}
          />
        );
      case "PrimarySpec":
        return <AttrPrimarySpec value={value} />;
      case "SpecsSelectTable":
        return (
          <AttrSpecsSelectTable
            value={value}
            onChange={onChange}
            disabled={disabled}
            component={component}
            onBlur={onBlur}
          />
        );
    }
  }
  return (
    <AttrEditDefault
      attr={attr}
      value={value}
      onChange={onChange}
      disabled={disabled}
      activateCallback={activateCallback}
      onBlur={onBlur}
    />
  );
};
